import { notificationsMixin } from './notifications';

export const minimalModalNoSchemaMixin = {
  mixins: [notificationsMixin],
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    // @vuese
    // Funkcja emituje event `close` do zamknięcia modalu
    close() {
      // Zamyka modal
      this.$emit('close');
    }
  }
};
